import { Footer } from "./components/Footer";
import { Header } from "./components/Header";
import { useEffect } from "react";

const TermsOfService = () => {
    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const handleScroll = (event) => {
        let scrollTop = document.documentElement.scrollTop;
        if (
            scrollTop > 40 &&
            !document.body.classList.contains("header-fixed")
        ) {
            document.body.classList.add("header-fixed");
        }
        if (scrollTop <= 40) {
            document.body.classList.remove("header-fixed");
        }
    };

    return (
        <div className="site-container">
            <div className="h-d-outer-cont">
                <div className="h-d-inner-cont no-pad-bottom">
                    <Header />
                </div>
            </div>
            <div className="cookies-text-cont terms-text-cont d-flex justify-content-center align-items-center flex-column main-site-wrapper">
                <h1 className="cookies-header-text">
                    Terms of Use / End User License Agreement
                </h1>
                <div className="cookies-subheader-text">
                    Retreat Sounds &mdash; Last Updated: September 2, 2026
                </div>

                <div className="cookies-module-cont">
                    <div className="cookies-module-cont">
                        <p>
                            These Terms of Use, including any terms
                            incorporated by reference (the "Terms"), constitute
                            a legally binding agreement between you ("you" or
                            "User") and Retreat Sounds, LLC ("Retreat Sounds,"
                            "we," "us," or "our") governing your access to and
                            use of the Retreat Sounds mobile application,
                            including all related content, features, and
                            services (collectively, the "App").
                        </p>
                        <p>
                            By downloading, installing, accessing, or using the
                            App, you agree to be bound by these Terms. If you
                            do not agree, do not use the App. Our Privacy
                            Policy, available at{" "}
                            <a
                                href="https://privacy.retreatsounds.com/"
                                target="_blank"
                                rel="noreferrer"
                            >
                                https://privacy.retreatsounds.com/
                            </a>
                            , is incorporated into these Terms by reference and
                            describes how we collect, use, and share
                            information.
                        </p>
                    </div>
                </div>

                <div className="cookies-module-cont">
                    <div className="cookies-module-header">1. Eligibility</div>
                    <div className="cookies-module-cont">
                        <p>
                            You must be at least 13 years old (or the minimum
                            age of digital consent in your jurisdiction) to use
                            the App. If you are under the age of majority in
                            your jurisdiction, you may only use the App under
                            the supervision of a parent or legal guardian who
                            agrees to be bound by these Terms on your behalf.
                            By using the App, you represent that you meet these
                            requirements.
                        </p>
                    </div>
                </div>

                <div className="cookies-module-cont">
                    <div className="cookies-module-header">
                        2. License Grant
                    </div>
                    <div className="cookies-module-cont">
                        <p>
                            Subject to your compliance with these Terms, we
                            grant you a limited, non-exclusive,
                            non-transferable, non-sublicensable, revocable
                            license to download, install, and use the App on a
                            device that you own or control, solely for your
                            personal, non-commercial use.
                        </p>
                        <p>This license does not permit you to:</p>
                        <ul>
                            <li>
                                Copy, modify, adapt, translate, or create
                                derivative works of the App or its content;
                            </li>
                            <li>
                                Reverse engineer, decompile, or disassemble the
                                App, except to the extent such restriction is
                                prohibited by applicable law;
                            </li>
                            <li>
                                Rent, lease, lend, sell, redistribute, or
                                sublicense the App;
                            </li>
                            <li>
                                Remove, obscure, or alter any proprietary
                                notices on the App;
                            </li>
                            <li>
                                Use the App for any commercial purpose,
                                including public performance or broadcast of
                                audio content, without our prior written
                                consent;
                            </li>
                            <li>
                                Use the App in any way that violates applicable
                                law or infringes the rights of any third party.
                            </li>
                        </ul>
                        <p>
                            All rights not expressly granted to you are
                            reserved by Retreat Sounds and its licensors.
                        </p>
                    </div>
                </div>

                <div className="cookies-module-cont">
                    <div className="cookies-module-header">
                        3. Content and Intellectual Property
                    </div>
                    <div className="cookies-module-cont">
                        <p>
                            All audio tracks, guided sessions, music,
                            soundscapes, artwork, text, graphics, logos,
                            trademarks, and other materials made available
                            through the App ("Content") are owned by Retreat
                            Sounds or our licensors and are protected by
                            copyright, trademark, and other intellectual
                            property laws.
                        </p>
                        <p>
                            You may stream and, where the App expressly enables
                            it, download Content for offline personal use
                            within the App. Content is licensed to you, not
                            sold. You acquire no ownership rights in any
                            Content.
                        </p>
                        <p>
                            Some Content may be provided by third-party
                            licensors. Such Content remains subject to the
                            applicable licensor's rights, and your use of it
                            may be subject to additional terms we make
                            available within the App.
                        </p>
                    </div>
                </div>

                <div className="cookies-module-cont">
                    <div className="cookies-module-header">
                        4. Subscriptions
                    </div>
                    <div className="cookies-module-cont">
                        <h3>4.1 Subscription Plans</h3>
                        <p>
                            The App offers auto-renewing subscription plans
                            ("Subscription") that unlock premium features and
                            Content, as described within the App at the time of
                            purchase. Pricing, billing frequency (e.g.,
                            monthly, annual), and included features are
                            disclosed prior to purchase.
                        </p>
                        <h3>4.2 Billing and Auto-Renewal</h3>
                        <ul>
                            <li>
                                Subscriptions automatically renew for the same
                                duration and at the then-current price unless
                                you cancel at least 24 hours before the end of
                                the current billing period.
                            </li>
                            <li>
                                Your payment method will be charged through the
                                platform via which you purchased the
                                Subscription &mdash; the Apple App Store or
                                Google Play Store (each, a "Platform").
                            </li>
                            <li>
                                Any unused portion of a free trial period, if
                                offered, is forfeited when you purchase a
                                Subscription during the trial.
                            </li>
                        </ul>
                        <h3>4.3 Managing and Cancelling Subscriptions</h3>
                        <p>
                            Subscriptions are managed through your Platform
                            account settings, not directly through Retreat
                            Sounds:
                        </p>
                        <ul>
                            <li>
                                iOS: Settings &gt; [Your Name] &gt;
                                Subscriptions
                            </li>
                            <li>
                                Android: Google Play app &gt; Menu &gt;
                                Subscriptions
                            </li>
                        </ul>
                        <p>
                            Deleting the App does not cancel your Subscription.
                            You must cancel through your Platform account.
                        </p>
                        <h3>4.4 Refunds</h3>
                        <p>
                            All billing is handled by the Platform through
                            which you subscribed. Refund requests are subject
                            to the Platform's refund policies:
                        </p>
                        <ul>
                            <li>
                                Apple App Store:{" "}
                                <a
                                    href="https://support.apple.com/en-us/HT204084"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    https://support.apple.com/en-us/HT204084
                                </a>
                            </li>
                            <li>
                                Google Play:{" "}
                                <a
                                    href="https://support.google.com/googleplay/answer/2479637"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    https://support.google.com/googleplay/answer/2479637
                                </a>
                            </li>
                        </ul>
                        <p>
                            We do not directly process payments or issue
                            refunds except where required by applicable law.
                        </p>
                        <h3>4.5 Price Changes</h3>
                        <p>
                            We may change Subscription pricing from time to
                            time. Any price change will apply starting with
                            your next billing cycle after we provide notice, as
                            required by applicable law and Platform policy.
                            Continuing to use the Subscription after a price
                            change constitutes acceptance of the new price.
                        </p>
                    </div>
                </div>

                <div className="cookies-module-cont">
                    <div className="cookies-module-header">
                        5. Health and Wellness Disclaimer
                    </div>
                    <div className="cookies-module-cont">
                        <p>
                            The App provides audio content intended for
                            relaxation, sleep support, mindfulness, and general
                            wellness purposes. The App and its Content:
                        </p>
                        <ul>
                            <li>
                                Are not a substitute for professional medical,
                                psychological, or psychiatric advice,
                                diagnosis, or treatment;
                            </li>
                            <li>
                                Should not be relied upon in a medical
                                emergency or mental health crisis;
                            </li>
                            <li>
                                Are provided "as is" and are not guaranteed to
                                produce any specific outcome.
                            </li>
                        </ul>
                        <p>
                            If you are experiencing a medical or mental health
                            emergency, contact emergency services or a crisis
                            hotline in your area immediately. Consult a
                            qualified healthcare provider before using the App
                            if you have a medical condition, are pregnant, or
                            have concerns about how relaxation audio, binaural
                            tones, or similar content may affect you (e.g.,
                            photosensitive epilepsy or similar conditions,
                            where applicable).
                        </p>
                    </div>
                </div>

                <div className="cookies-module-cont">
                    <div className="cookies-module-header">
                        6. User Accounts
                    </div>
                    <div className="cookies-module-cont">
                        <p>
                            If the App requires an account, you are responsible
                            for maintaining the confidentiality of your login
                            credentials and for all activity under your
                            account. Notify us promptly at support@retreatsounds.com of
                            any unauthorized use.
                        </p>
                    </div>
                </div>

                <div className="cookies-module-cont">
                    <div className="cookies-module-header">
                        7. User Conduct
                    </div>
                    <div className="cookies-module-cont">
                        <p>You agree not to:</p>
                        <ul>
                            <li>Use the App for any unlawful purpose;</li>
                            <li>
                                Upload or transmit any harmful code, virus, or
                                malicious software;
                            </li>
                            <li>
                                Attempt to gain unauthorized access to our
                                systems or other users' accounts;
                            </li>
                            <li>
                                Interfere with or disrupt the App's servers or
                                networks;
                            </li>
                            <li>
                                Use automated means (bots, scrapers) to access
                                the App without our permission;
                            </li>
                            <li>
                                Circumvent, disable, or otherwise interfere
                                with security-related or DRM features of the
                                App.
                            </li>
                        </ul>
                        <p>
                            We reserve the right to suspend or terminate your
                            access if we believe, in our reasonable discretion,
                            that you have violated these Terms.
                        </p>
                    </div>
                </div>

                <div className="cookies-module-cont">
                    <div className="cookies-module-header">
                        8. Third-Party Services
                    </div>
                    <div className="cookies-module-cont">
                        <p>
                            The App may integrate with third-party services
                            (e.g., analytics providers, payment platforms,
                            cloud storage). Your use of such services may be
                            subject to their own terms and privacy policies,
                            which we encourage you to review. We are not
                            responsible for the practices of third parties.
                        </p>
                    </div>
                </div>

                <div className="cookies-module-cont">
                    <div className="cookies-module-header">9. Termination</div>
                    <div className="cookies-module-cont">
                        <p>
                            We may suspend or terminate your access to the App
                            at any time, with or without cause or notice,
                            including if you breach these Terms. You may stop
                            using the App and delete it at any time.
                            Termination does not entitle you to a refund of any
                            amounts already paid, except as required by law or
                            Platform policy. Sections of these Terms that by
                            their nature should survive termination (e.g.,
                            intellectual property, disclaimers, limitation of
                            liability) will survive.
                        </p>
                    </div>
                </div>

                <div className="cookies-module-cont">
                    <div className="cookies-module-header">
                        10. Disclaimer of Warranties
                    </div>
                    <div className="cookies-module-cont">
                        <p>
                            THE APP AND ALL CONTENT ARE PROVIDED "AS IS" AND
                            "AS AVAILABLE," WITHOUT WARRANTIES OF ANY KIND,
                            WHETHER EXPRESS, IMPLIED, OR STATUTORY, INCLUDING
                            WITHOUT LIMITATION WARRANTIES OF MERCHANTABILITY,
                            FITNESS FOR A PARTICULAR PURPOSE, NON-INFRINGEMENT,
                            OR THAT THE APP WILL BE UNINTERRUPTED, ERROR-FREE,
                            OR SECURE. WE DO NOT WARRANT THAT THE APP WILL MEET
                            YOUR REQUIREMENTS OR PRODUCE ANY PARTICULAR HEALTH,
                            WELLNESS, OR SLEEP-RELATED OUTCOME.
                        </p>
                        <p>
                            Some jurisdictions do not allow the exclusion of
                            certain warranties, so some of the above exclusions
                            may not apply to you.
                        </p>
                    </div>
                </div>

                <div className="cookies-module-cont">
                    <div className="cookies-module-header">
                        11. Limitation of Liability
                    </div>
                    <div className="cookies-module-cont">
                        <p>
                            TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW,
                            RETREAT SOUNDS AND ITS OFFICERS, EMPLOYEES, AND
                            LICENSORS SHALL NOT BE LIABLE FOR ANY INDIRECT,
                            INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE
                            DAMAGES, OR ANY LOSS OF PROFITS, DATA, OR GOODWILL,
                            ARISING FROM OR RELATED TO YOUR USE OF THE APP,
                            EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.
                        </p>
                        <p>
                            OUR TOTAL AGGREGATE LIABILITY FOR ANY CLAIM ARISING
                            FROM THESE TERMS OR YOUR USE OF THE APP SHALL NOT
                            EXCEED THE GREATER OF (A) THE AMOUNT YOU PAID US IN
                            THE TWELVE (12) MONTHS PRECEDING THE CLAIM, OR (B)
                            FIFTY U.S. DOLLARS (USD $50).
                        </p>
                        <p>
                            Some jurisdictions do not allow the limitation or
                            exclusion of liability, so some of the above
                            limitations may not apply to you.
                        </p>
                    </div>
                </div>

                <div className="cookies-module-cont">
                    <div className="cookies-module-header">
                        12. Indemnification
                    </div>
                    <div className="cookies-module-cont">
                        <p>
                            You agree to indemnify and hold harmless Retreat
                            Sounds and its officers, employees, and licensors
                            from any claims, damages, liabilities, and expenses
                            (including reasonable attorneys' fees) arising from
                            your violation of these Terms or your misuse of the
                            App.
                        </p>
                    </div>
                </div>

                <div className="cookies-module-cont">
                    <div className="cookies-module-header">
                        13. Apple App Store Terms
                    </div>
                    <div className="cookies-module-cont">
                        <p>
                            If you downloaded the App from the Apple App Store,
                            you acknowledge the following additional terms:
                        </p>
                        <ul>
                            <li>
                                These Terms are between you and Retreat Sounds
                                only, not with Apple, and Apple is not
                                responsible for the App or its Content.
                            </li>
                            <li>
                                Apple has no obligation to provide maintenance
                                or support for the App.
                            </li>
                            <li>
                                In the event of any failure of the App to
                                conform to any applicable warranty, you may
                                notify Apple, and Apple will refund the
                                purchase price, if any, for the App; to the
                                maximum extent permitted by law, Apple has no
                                other warranty obligation with respect to the
                                App.
                            </li>
                            <li>
                                Apple is not responsible for addressing any
                                claims relating to the App, including product
                                liability claims, legal compliance claims, or
                                claims under consumer protection laws.
                            </li>
                            <li>
                                Apple is not responsible for investigating,
                                defending, settling, or discharging any
                                third-party claim that the App infringes
                                intellectual property rights.
                            </li>
                            <li>
                                You represent that you are not located in a
                                country subject to a U.S. government embargo
                                and are not on any U.S. government list of
                                prohibited or restricted parties.
                            </li>
                            <li>
                                Apple and its subsidiaries are third-party
                                beneficiaries of these Terms and may enforce
                                them against you.
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="cookies-module-cont">
                    <div className="cookies-module-header">
                        14. Google Play Terms
                    </div>
                    <div className="cookies-module-cont">
                        <p>
                            If you downloaded the App from Google Play, your
                            use is also subject to Google Play's Terms of
                            Service, available at{" "}
                            <a
                                href="https://play.google.com/intl/en-us/about/play-terms/"
                                target="_blank"
                                rel="noreferrer"
                            >
                                https://play.google.com/intl/en-us/about/play-terms/
                            </a>
                            . In the event of a conflict between these Terms
                            and Google Play's terms with respect to your use of
                            the App, Google Play's terms will control solely to
                            the extent of that conflict.
                        </p>
                    </div>
                </div>

                <div className="cookies-module-cont">
                    <div className="cookies-module-header">
                        15. Changes to the App and Terms
                    </div>
                    <div className="cookies-module-cont">
                        <p>
                            We may update, modify, or discontinue the App (or
                            any feature) at any time. We may revise these Terms
                            from time to time. If we make material changes, we
                            will notify you through the App or by other
                            reasonable means. Continued use of the App after
                            changes take effect constitutes acceptance of the
                            revised Terms.
                        </p>
                    </div>
                </div>

                <div className="cookies-module-cont">
                    <div className="cookies-module-header">
                        16. Governing Law and Dispute Resolution
                    </div>
                    <div className="cookies-module-cont">
                        <p>
                            These Terms are governed by the laws of the State
                            of Tennessee, United States of America, without
                            regard to conflict-of-law principles. Any dispute
                            arising out of or relating to these Terms or the
                            App shall be brought exclusively in the state or
                            federal courts located in Davidson County,
                            Tennessee, and you consent to the personal
                            jurisdiction of those courts. Nothing in this
                            section limits any non-waivable consumer
                            protection rights you may have under the laws of
                            your country or state of residence.
                        </p>
                    </div>
                </div>

                <div className="cookies-module-cont">
                    <div className="cookies-module-header">
                        17. Severability
                    </div>
                    <div className="cookies-module-cont">
                        <p>
                            If any provision of these Terms is found
                            unenforceable, the remaining provisions will remain
                            in full force and effect.
                        </p>
                    </div>
                </div>

                <div className="cookies-module-cont">
                    <div className="cookies-module-header">
                        18. Entire Agreement
                    </div>
                    <div className="cookies-module-cont">
                        <p>
                            These Terms, together with our Privacy Policy,
                            constitute the entire agreement between you and
                            Retreat Sounds regarding the App and supersede any
                            prior agreements.
                        </p>
                    </div>
                </div>

                <div className="cookies-module-cont">
                    <div className="cookies-module-header">19. Contact Us</div>
                    <div className="cookies-module-cont">
                        <p>
                            If you have questions about these Terms, contact us
                            at:
                        </p>
                        <p>
                            Address:
                            <br />
                            Retreat Sounds LLC
                            <br />
                            320 Seven Springs Way
                            <br />
                            Brentwood, TN 37027-4537, USA
                            <br />
                            Email:{" "}
                            <a href="mailto:support@retreatsounds.com">
                                support@retreatsounds.com
                            </a>
                        </p>
                    </div>
                </div>
            </div>
            <Footer hidePattern={true} />
        </div>
    );
};
export default TermsOfService;
